module.exports = __webpack_public_path__ + "img/auth-logo.2ada013a.svg";